import React from "react";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";
import {
  EditorCanvasScrollbarItem,
  EditorCanvasTextItem,
  EditorCanvasButtonItem,
  EditorCanvasImageItem,
  EditorCanvasShapeItem,
} from "./index";
import { EditorCanvasShapeStrokeOverlay } from "./EditorCanvasShapeStrokeOverlay";

export const EditorCanvasItems = () => {
  const {
    layerCompData,
    isDragged,
    sendSelectedComponent,
    setFroalaIndex,
    setToggleSelected,
    setVisibility,
  } = useEditorMainPageContext();

  return (
    <>
      {layerCompData &&
        layerCompData.map((items, index) => (
          <div
            onMouseDown={() => {
              isDragged.mouseDown = true;
              isDragged.mouseMove = false;
            }}
            onMouseMove={() => {
              if (isDragged.mouseDown === true) isDragged.mouseMove = true;
            }}
            onMouseUp={() => {
              isDragged.mouseDown = false;
            }}
            onClick={(e) => {
              sendSelectedComponent(e, index);
              setFroalaIndex(index);
              setToggleSelected(true);
              setVisibility(false);
            }}
            key={items.id + index}
          >
            <div>
              <EditorCanvasScrollbarItem items={items} index={index} />
            </div>
            <EditorCanvasTextItem items={items} index={index} />
            <EditorCanvasButtonItem items={items} index={index} />
            <EditorCanvasImageItem items={items} index={index} />
            <EditorCanvasShapeItem items={items} index={index} />
          </div>
        ))}
      {/* Paint shape frames after all layers so borders stay above same-size content. */}
      {layerCompData &&
        layerCompData.map((items) =>
          items?.componentType === "Shape" ? (
            <EditorCanvasShapeStrokeOverlay key={`${items.id}-stroke`} items={items} />
          ) : null,
        )}
    </>
  );
};
